var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmxCinebistro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 390 156",
    style: {
      enableBackground: "new 0 0 390 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "151.4,115.7 151.4,115.7 151.4,115.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "359.9,5.1 318.7,5.1 339.6,35.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.3,113.6c-29.5,0-53.4-23.8-53.4-53.3C6.9,30.8,30.7,7,60.2,6.9c17.9,0,34.7,9,44.6,23.9l5.5-4.3 C91.7-1,54.2-8.3,26.6,10.3S-8.3,66.4,10.3,94s56.1,34.9,83.7,16.3c6.9-4.7,12.8-10.7,17.2-17.7l-5.7-4.1 C95.8,104,78.7,113.5,60.3,113.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.3,87.2c-14.8,0-26.8-12.1-26.8-26.9c0-14.8,12.1-26.8,26.9-26.7c9.6,0,18.5,5.2,23.2,13.5l19.7-15.2 C87.8,8.1,55.8,1.5,31.9,17.1S1.5,64.7,17.1,88.5s47.7,30.4,71.5,14.8c6.3-4.1,11.6-9.6,15.6-16L84.1,73 C79.4,81.7,70.3,87.2,60.3,87.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "239.4,115.7 204.2,115.7 239.5,59.3  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.4,
    y: 5.2,
    className: "st0",
    width: 7,
    height: 110.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "206.5,5.2 180.2,47.9 153.8,5.2 130.1,5.2 130.1,115.7 151.9,115.7 151.9,52.2 180.2,95.5 180.7,95.5  238.9,5.9 239.4,5.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "361,115.7 283.7,5.1 275.7,5.1 351.8,115.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "246.4,5.1 282.8,59.5 244.9,115.7 283.8,115.7 302.8,85.8 321.7,115.7 349.6,115.7 273.6,5.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M373.4,112.5c0,1.4,1,1.9,2.3,1.9c1.3,0,1.9-0.7,1.9-1.4c0-0.5-0.3-1-0.8-1.1c-0.6-0.3-1.5-0.4-2.7-0.8 c-1.2-0.1-2.1-1.1-2.1-2.3c0-1.8,1.7-2.7,3.3-2.7c1.6,0,3.6,1,3.6,2.9h-1.5c0-1.2-0.9-1.6-2-1.6c-0.7,0-1.7,0.3-1.7,1.2 c0,0.6,0.4,1,1.1,1.2c0.1,0,2.1,0.6,2.6,0.7c1.1,0.3,1.8,1.2,1.8,2.3c0,2-1.8,2.8-3.6,2.8c-2.1,0-3.8-1-3.8-3.2L373.4,112.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "380.6,106.4 382.8,106.4 385.3,113.5 385.3,113.5 387.8,106.4 390,106.4 390,115.5 388.5,115.5  388.5,108.5 388.5,108.5 386,115.5 384.6,115.5 382.1,108.5 382.1,108.5 382.1,115.5 380.6,115.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,144.4L5,144.4c-0.1-6.3,4.9-11.6,11.2-11.7c0.2,0,0.3,0,0.5,0c3.3-0.2,6.6,1.1,8.9,3.5l-3.2,3.6 c-1.5-1.5-3.6-2.4-5.7-2.5c-3.7,0.1-6.6,3.1-6.6,6.8c0,0.1,0,0.1,0,0.2l0,0c-0.2,3.7,2.6,6.9,6.3,7.1c0.1,0,0.2,0,0.2,0 c2.2,0,4.3-1,5.9-2.6l3.2,3.2c-2.3,2.7-5.7,4.2-9.3,4c-6.3,0.1-11.5-4.9-11.6-11.2C5,144.7,5,144.5,5,144.4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.7,
    y: 133.1,
    className: "st0",
    width: 5,
    height: 22.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "40,133.1 44.6,133.1 55.2,146.9 55.2,133.1 60.1,133.1 60.1,155.6 55.9,155.6 44.9,141.3 44.9,155.6  40,155.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "65.2,133.1 82.3,133.1 82.3,137.5 70.2,137.5 70.2,142 80.8,142 80.8,146.5 70.2,146.5 70.2,151.2  82.4,151.2 82.4,155.6 65.2,155.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "86.5,133.1 91.9,133.1 97.8,142.6 103.8,133.1 109.1,133.1 109.1,155.6 104.2,155.6 104.2,140.9  97.8,150.5 97.7,150.5 91.4,141 91.4,155.6 86.5,155.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.7,132.9h4.6l9.7,22.7h-5.2l-2.1-5.2h-9.5l-2.1,5.1H111L120.7,132.9z M125.9,146.2l-2.9-7.3l-3,7.3H125.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134.9,152.3l2.9-3.5c1.8,1.7,4.2,2.7,6.7,2.7c2,0,3.3-0.8,3.3-2.1l0,0c0-1.3-0.8-1.9-4.5-2.9 c-4.6-1.2-7.5-2.4-7.5-6.9l0,0c0-4.1,3.3-6.8,7.9-6.8c3,0,6,1,8.4,2.9l-2.6,3.7c-1.7-1.3-3.7-2.1-5.9-2.2c-1.9,0-2.9,0.9-2.9,2l0,0 c0,1.5,1,2,4.9,2.9c4.6,1.2,7.2,2.8,7.2,6.8l0,0c0,4.5-3.4,7-8.3,7C141,155.9,137.6,154.6,134.9,152.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.1,144L176.1,144c0-6.2,4.7-11,11.1-11c4.3,0,7.1,1.8,9,4.4l-4.4,3.4c-1.2-1.5-2.6-2.5-4.6-2.5 c-3,0-5,2.5-5,5.6v0.1c0,3.2,2.1,5.6,5,5.6c2.2,0,3.5-1,4.8-2.6l4.4,3.1c-2,2.7-4.7,4.8-9.4,4.8C181,154.9,176.1,150.3,176.1,144z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199,133.3h5.9v21.1H199V133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.8,133.3h5.5l8.7,11.2v-11.2h5.8v21.1h-5.1l-9-11.6v11.6h-5.8V133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M232.5,133.3h17v5h-11.2v3.2h10.1v4.6h-10.1v3.3h11.3v5h-17.1V133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256.6,133.3h9c2.4,0,4.3,0.7,5.5,1.9c0.9,0.9,1.4,2,1.4,3.4v0.1c0,2.7-1.7,4.2-3.4,4.9 c2.5,0.8,4.5,2.2,4.5,5.1v0.1c0,3.6-3,5.8-7.7,5.8h-9.4V133.3z M265.2,142.8c2.9,0,4.9-1.3,4.9-3.8v-0.1c0-2.1-1.7-3.4-4.7-3.4 H259v7.3H265.2z M266.1,152.3c3.2,0,5.2-1.4,5.2-3.8v-0.1c0-2.3-1.9-3.6-5.6-3.6H259v7.4H266.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.8,133.3h2.4v21.1h-2.4V133.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M282.2,151.4l1.5-1.7c2.2,2,4.3,3,7.2,3c2.8,0,4.7-1.5,4.7-3.6V149c0-2-1.1-3.1-5.5-4 c-4.9-1.1-7.1-2.6-7.1-6.1v-0.1c0-3.3,2.9-5.8,6.9-5.8c3.1,0,5.3,0.9,7.4,2.6l-1.4,1.8c-2-1.6-3.9-2.3-6.1-2.3 c-2.7,0-4.5,1.5-4.5,3.4v0.1c0,2,1.1,3.1,5.7,4.1c4.7,1,6.9,2.7,6.9,6v0.1c0,3.6-3,6-7.2,6C287.5,154.8,284.7,153.6,282.2,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306.2,135.5h-7.1v-2.2h16.6v2.2h-7.1v18.9h-2.4V135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.4,133.3h9.1c2.6,0,4.7,0.8,6,2.1c1,1,1.6,2.5,1.6,4.2v0.1c0,3.5-2.4,5.5-5.7,6.2l6.5,8.6h-2.9l-6.1-8.2 h-6v8.2h-2.4V133.3z M327.3,144.1c3.2,0,5.4-1.6,5.4-4.3v-0.1c0-2.6-2-4.2-5.4-4.2h-6.5v8.6H327.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.5,144L337.5,144c0-5.9,4.4-11,10.8-11s10.7,5,10.7,10.9v0.1c0,5.8-4.4,10.9-10.8,10.9 C341.8,154.8,337.5,149.8,337.5,144z M356.6,144L356.6,144c0-4.9-3.5-8.8-8.3-8.8s-8.3,3.9-8.3,8.7v0.1c0,4.8,3.5,8.7,8.3,8.7 S356.6,148.8,356.6,144z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 131.4,
    className: "st0",
    width: 3.7,
    height: 24.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.6,
    y: 124.5,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 370.7536 -112.5556)",
    className: "st0",
    width: 4.1,
    height: 9.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmxCinebistro);
export default __webpack_public_path__ + "static/media/cmx-cinebistro.f3e0a8aa84d863aae4d0a4ea68dd4960.svg";
export { ForwardRef as ReactComponent };